module.exports = __webpack_public_path__ + "img/service-swiper-1-pic.49135cc3.png";